import React, { useEffect, useState } from "react";
import axios from "axios";
import SyncConstants from "../../constants/SyncConstants";
import useAuthentication from "../../hooks/useAuthentication";
import moment from "moment";
import "./ActivityFeed.scss";

const ActivityFeed = ({ limit = 50, compact = false }) => {
    const Auth = useAuthentication();
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadActivities();
    }, [limit]);

    const loadActivities = () => {
        setLoading(true);
        axios({
            method: "get",
            url: SyncConstants["syncBaseURL"] + "user/activities",
            auth: Auth.getAuthObject()
        }).then(response => {
            if (response.data.success) {
                const limitedActivities = limit ? response.data.data.slice(0, limit) : response.data.data;
                setActivities(limitedActivities);
            }
            setLoading(false);
        }).catch(error => {
            console.error("Error loading activities:", error);
            setLoading(false);
        });
    };

    const getActivityIcon = (type) => {
        if (type.includes('slot')) return 'bi-calendar-event';
        if (type.includes('expense')) return 'bi-clock-history';
        if (type.includes('invoice')) return 'bi-receipt';
        if (type.includes('project')) return 'bi-folder';
        if (type.includes('user')) return 'bi-person';
        if (type.includes('changePassword')) return 'bi-shield-lock';
        return 'bi-circle-fill';
    };

    const getActivityColor = (type) => {
        if (type.includes('slot')) return 'text-primary';
        if (type.includes('expense')) return 'text-success';
        if (type.includes('invoice')) return 'text-warning';
        if (type.includes('project')) return 'text-info';
        if (type.includes('user')) return 'text-secondary';
        if (type.includes('changePassword')) return 'text-danger';
        return 'text-secondary';
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Lade Aktivitäten...</span>
                </div>
            </div>
        );
    }

    if (activities.length === 0) {
        return (
            <div className="text-center py-5 text-muted">
                <i className={`bi bi-inbox activity-feed-empty-icon--${compact ? 'compact' : 'normal'}`}></i>
                <p className="mt-3">Noch keine Aktivitäten vorhanden</p>
            </div>
        );
    }

    return (
        <div className="list-group list-group-flush">
            {activities.map((activity, index) => (
                <div key={index} className={`list-group-item px-0 ${compact ? 'py-2' : 'py-3'}`}>
                    <div className="d-flex align-items-start">
                        <div
                            className={`me-3 ${getActivityColor(activity.type)} activity-feed-item-icon--${compact ? 'compact' : 'normal'}`}
                        >
                            <i className={`bi ${getActivityIcon(activity.type)}`}></i>
                        </div>
                        <div className="flex-grow-1">
                            <div className={compact ? 'small' : 'fw-semibold'}>
                                {activity.description}
                            </div>
                            <small className="text-muted">
                                <i className="bi bi-clock me-1"></i>
                                {moment(activity.created_at).format("DD.MM.YYYY HH:mm")} Uhr
                                {!compact && (
                                    <>
                                        <span className="mx-2">•</span>
                                        {moment(activity.created_at).fromNow()}
                                    </>
                                )}
                            </small>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ActivityFeed;
